import type { LogBasedError, TriageError } from './types';
import { DEFAULT_RUNBOOK_LINK, runbookLink } from './types';

/**
 * These are produced by the extension and should be investigated/fixed.
 * Once the added Linear ticket is done, these should be removed from here.
 */
export const extensionTriageErrors: TriageError[] = [
  {
    messageContains: 'Failed to get missing charts',
    threshold: 10,
    priority: 5,
    ticket: 'ENG-1800',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    messageContains: 'Failed to backfill missing charts',
    threshold: 10,
    priority: 5,
    ticket: 'ENG-1800',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    title: 'No summary available to display to user',
    messageContains: 'No summary available to display to user',
    threshold: 1,
    priority: 4,
    ticket: 'ENG-1857',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    messageContains: 'Failed to import chart templates',
    threshold: 5,
    priority: 4,
    ticket: 'ENG-1886',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    messageContains: 'Failed to start microphone preview',
    threshold: 1,
    priority: 5,
    ticket: 'ENG-2283',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    // Signature of a session that captured ZERO audio (dead encoder worker).
    // The extension is immune to the ENG-5284 stale-tab asset-404 class
    // (assets ship in the .crx) but shares the recorder code, so this covers
    // the still-unexplained current-build residual class (ENG-5286). No
    // `status`, so a later log-level change cannot blind the monitor.
    title: 'Segments finalized with no local audio file',
    messageContains: 'Segment finalized with no local audio file',
    threshold: 10,
    priority: 4,
    evaluationWindow: '4h',
    ticket: 'ENG-5284',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    // Pinned against convention: matches only pre-fix clients, and dropping it
    // would leak their error logs into the unknown-error monitor.
    status: 'error',
    title: 'Recording finalize timed out',
    messageContains: 'Recording finalize timed out',
    threshold: 10,
    priority: 4,
    evaluationWindow: '4h',
    ticket: 'ENG-5457',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    // threshold 1: zero occurrences in retained production logs, so one hit is signal.
    title: 'Encoder worker stop handshake timed out',
    messageContains: 'Encoder worker stop handshake timed out',
    threshold: 1,
    priority: 4,
    ticket: 'ENG-5741',
    notionLink: runbookLink('aba22b93705f42a8a3f24ad50b8fa6b0'),
  },
];

/**
 * These are produced by the extension, but are not going to be fixed
 * either because they don't have a fix or because we have chosen not to.
 */
export const extensionKnownErrors: LogBasedError[] = [
  {
    title: 'Recording Exception: Error getting audio stream',
    messageContains: 'Recording Exception',
    jsonContains: {
      error: '*error?occurred?while?getting?stream?from?audio?input?device*',
    },
    threshold: 2,
    priority: 4,
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    messageContains: 'Error processing content message',
    jsonContains: {
      error: '(-*FILE_ERROR_NO_SPACE*)',
    },
    threshold: 3,
    priority: 4,
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    messageContains: 'Failed to sync data to EHR',
    threshold: 3,
    priority: 4,
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    messageContains: 'Failed to import patients',
    status: 'warn',
    threshold: 10,
    priority: 4,
    evaluationWindow: '1h',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    messageContains: 'Failed to import appointments',
    status: 'warn',
    threshold: 10,
    priority: 4,
    evaluationWindow: '1h',
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
  {
    title: 'Transient network failure uploading audio chunk to GCS',
    messageContains: 'Error uploading chunk to GCS',
    jsonContains: {
      error: '*Failed?to?fetch*',
    },
    threshold: 5,
    priority: 4,
    notionLink: DEFAULT_RUNBOOK_LINK,
  },
];
